// Real pages from DRUM READY Volume 1 (WebP in Impultienda Recursos, store DRUM READY).
const R = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/81daa30f-3f61-480f-a536-2affd069f30c/';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: R + '1792782700639_dr-vol1-p01-cover-d26bc477.webp',
  label: 'Volume 1 · Cover',
  title: 'Studio Year Plan & 12 Ready-to-Teach Lessons',
  text: 'Three tracks – Young Beginners 6–9, Older Beginners 10–14, Teens & Adults – with 30, 45 and 60-minute lessons, printable worksheets and tests with answer keys.'
}, {
  src: R + '1792782704605_dr-vol1-p05-yearplan-18a0fd32.webp',
  label: 'Year plan · Page 5',
  title: '36-Week Plan · Young Beginners (6–9)',
  text: 'Week by week, from Meet the Drum Kit to the studio showcase and level-up check – so you always know what comes next.'
}, {
  src: R + '1792782708682_dr-vol1-p12-lesson1-7b74f758.webp',
  label: 'Lesson 1 · Page 12',
  title: 'Meet the Drum Kit · 30 min',
  text: 'Young Beginners (6–9): goal, materials, a minute-by-minute plan, a counting chart and a word-for-word teacher script.'
}, {
  src: R + '1792782712392_dr-vol1-p15-worksheet2-e5b7b549.webp',
  label: 'Worksheet 2 · Page 15',
  title: 'Beat Math in 3 Levels',
  text: 'The same skill at three levels, so every student in your studio can work on it – at their own pace.'
}, {
  src: R + '1792782716301_dr-vol1-p24-lesson7-3913a377.webp',
  label: 'Lesson 7 · Page 24',
  title: 'First Fills · 45 min',
  text: 'Older Beginners (10–14): 1-beat and 2-beat fills written as clear counting charts with sticking, plus a teacher script.'
}];
